import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { of, switchMap } from 'rxjs';

export const NoAuthGuard: CanActivateFn | CanActivateChildFn = (
    route,
    state
) => {
    const router: Router = inject(Router);

    // Check the authentication status
    return inject(AuthService)
        .check()
        .pipe(
            switchMap((authenticated) => {
                // If the user is authenticated...
                if (authenticated) {
                    // check if the user is
                    //  invited invite/:token url format or proposals/:proposalUUID/accept url format
                    const url = route['_routerState'] && route['_routerState'].url; // '/invite/2c8fc63c-f5ff-4e98-9e85-6fa7afa11bae'
                    const token = url?.split('/').pop(); // '2c8fc63c-f5ff-4e98-9e85-6fa7afa11bae'
                    const isInvitedLink = url?.includes('invite');
                    const isProposalLink = url?.includes('proposals');

                    if (isInvitedLink && token) {
                        return of(router.parseUrl('/invite/' + token + '/accept'));
                    }
                    
                    if (isProposalLink && token) {
                        return of(router.parseUrl('/proposals/' + token + '/accept'));
                    }
                    return of(router.parseUrl(''));
                }

                // Allow the access
                return of(true);
            })
        );
};
